import { render, staticRenderFns } from "./CartComponent.html?vue&type=template&id=2db4698b&scoped=true&"
import script from "./CartComponent.js?vue&type=script&lang=js&"
export * from "./CartComponent.js?vue&type=script&lang=js&"
import style0 from "./CartComponent.scss?vue&type=style&index=0&id=2db4698b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4698b",
  null
  
)

export default component.exports